var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24328",
    "data-name": "Group 24328",
    transform: "translate(-1021 -1001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12913",
    "data-name": "Rectangle 12913",
    width: 12,
    height: 12,
    transform: "translate(1021 1001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_003-mail",
    "data-name": "003-mail",
    transform: "translate(1021.661 927.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11975",
    "data-name": "Group 11975",
    transform: "translate(7.345 76.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11974",
    "data-name": "Group 11974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M355.449,101.721l-3.238,3.217,3.238,3.217a.928.928,0,0,0,.094-.4v-5.631A.928.928,0,0,0,355.449,101.721Z",
    transform: "translate(-352.211 -101.721)",
    fill: "#00101a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11977",
    "data-name": "Group 11977",
    transform: "translate(0.536 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11976",
    "data-name": "Group 11976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M34.923,76h-8.8a.927.927,0,0,0-.4.094l4.139,4.118a.939.939,0,0,0,1.327,0l4.139-4.118A.927.927,0,0,0,34.923,76Z",
    transform: "translate(-25.721 -76)",
    fill: "#00101a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11979",
    "data-name": "Group 11979",
    transform: "translate(0 76.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11978",
    "data-name": "Group 11978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M.094,101.721a.928.928,0,0,0-.094.4v5.631a.927.927,0,0,0,.094.4l3.238-3.217Z",
    transform: "translate(0 -101.721)",
    fill: "#00101a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11981",
    "data-name": "Group 11981",
    transform: "translate(0.536 80.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11980",
    "data-name": "Group 11980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M32.087,277.211l-.458.458a1.566,1.566,0,0,1-2.212,0l-.458-.458-3.238,3.217a.928.928,0,0,0,.4.094h8.8a.928.928,0,0,0,.4-.094Z",
    transform: "translate(-25.721 -277.211)",
    fill: "#00101a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.e1caa51ac30c74cbe0d551256d57cd6d.svg";
export { ForwardRef as ReactComponent };